module.exports = "../fonts/blue_mail_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue_mail_icon.svg
// module id = 117
// module chunks = 0